import { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import Box from '../../../Global/Box'
import HeatMapZones from '../../../Global/Maps/HeatMapZones'
import DatePickerInput from '../../../Global/DatePickerInput'
import ContentHeader from '../../../Layout/ContentHeader'
import { fnObjNameStatusReport } from '../../../../const/constStatuses'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import CategoryFilter from '../../Documents/ReportsCounters/components/CategoryFilter'
import KpiMultiCards from '../../Documents/ReportsCounters/components/KpiMultiCards'
import { GET_ALL_GROUPS_CATEGORIES_BY_IDS } from '../../../../graphql/Catalog/Groups/groupsCategories'
import { GET_ALL_JURISDICTIONS_AND_SUBS } from '../../../../graphql/Catalog/Jurisdictions/jurisdictions'
import { GET_ALL_REPORTS_FLAT } from '../../../../graphql/Catalog/Reports/reports'
import { GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID } from '../../../../graphql/Catalog/Groups/groupsCategoriesSubs'
import { currencyFormatToAny } from '../../../Helpers/FormatNumber'
import Loader from '../../../Global/Spinner'
const statusMap = fnObjNameStatusReport()

const options_status_report = [
  { value: 'all_reports', label: 'Generados' },
  { value: 'open_reports', label: 'En proceso' },
  { value: 'attended_reports', label: 'Atendidos' },
]
const reportsDataInitial = {
  open_reports: [],
  attended_reports: [],
  total: 0,
}

const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') return number
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const ReportsHeatMap = () => {
  const [filters, setFilters] = useState({
    array_group_category_id: null,
    array_group_category_sub_id: null,
    array_zones_id: null,
    status_report_type: 'all_reports',
    dateFrom: null,
    dateTo: null,
    special_priority: false,
  })
  const [options, setOptions] = useState({
    categories: [],
    subcategories: [],
    zones: [],
  })
  const [reportsData, setReportsData] = useState(reportsDataInitial)
  const [countsReportZones, setCountsReportZones] = useState(null)
  const [kpiCounts, setKpiCounts] = useState([])
  const [dataZoneCounts, setDataZoneCounts] = useState([])
  const [dataZoneCountsOrigin, setDataZoneCountsOrigin] = useState([])
  const [activeSort, setActiveSort] = useState(null)
  const [mapDataLoaded, setMapDataLoaded] = useState(false)

  //QUERIES
  const fetchReports = useQuery(GET_ALL_REPORTS_FLAT, {
    variables: { filters },
    fetchPolicy: 'no-cache',
  })

  const fetchCategories = useQuery(GET_ALL_GROUPS_CATEGORIES_BY_IDS, {
    fetchPolicy: 'no-cache',
  })

  const fetchJurisdictions = useQuery(GET_ALL_JURISDICTIONS_AND_SUBS, {
    fetchPolicy: 'no-cache',
  })

  const [getSubCategories] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID
  )

  //FUNCTIONS
  const handleFilterMultiplySelection = (e, field) => {
    let arraySend = []
    if (e.length > 0) {
      arraySend = e.map((item) => item.value)
    }
    setFilters((old) => ({
      ...old,
      [field]: arraySend,
    }))
  }

  const handleChangeFilterCategories = async (selected) => {
    if (selected?.length === 0) {
      setFilters({
        ...filters,
        array_group_category_id: null,
        array_group_category_sub_id: null,
      })
      setOptions({ ...options, subcategories: [] })
      return
    }

    //Optener las subcategorias de las categorias seleccionadas
    const {
      data: { getAllGroupsCategoriesSubByArrayCategoryId: subsCategories },
    } = await getSubCategories({
      variables: {
        array_group_category_id: selected.map((item) => item.value),
      },
      fetchPolicy: 'no-cache',
    })

    let listSubCategories = []

    if (subsCategories?.length > 0) {
      subsCategories.map((sub) => {
        listSubCategories.push({
          value: sub.id,
          label: sub.name,
          group_category_id: sub.group_category_id,
        })
      })
    }

    setOptions({
      ...options,
      subcategories: listSubCategories,
    })

    setFilters({
      ...filters,
      array_group_category_id: selected.map((item) => item.value),
    })
  }

  const handleChangeFilterCategoriesSub = async (selected) => {
    if (selected?.length === 0) {
      return setFilters({ ...filters, array_group_category_sub_id: null })
    }
    setFilters({
      ...filters,
      array_group_category_sub_id: selected.map((item) => item.value),
    })
  }

  const getTableCountZones = () => {
    return (
      <ul className="p-0">
        {dataZoneCounts.map((item, index) => {
          const classZebraRow = index % 2 === 0 ? 'zebra-row px-3' : 'px-3'
          return (
            <li key={item.id} className={classZebraRow}>
              <div style={{ padding: '5px 0px' }}>
                <span>{item?.name}</span>
                <span>
                  {/* <b>{item?.percentage}%</b>{' '} */}
                  <b>
                    {currencyFormatToAny({
                      value: item?.percentage ? item.percentage / 100 : 0,
                      style: 'percent',
                      decimalsMax: 2,
                      decimalsMin: 2,
                    })}
                  </b>
                  <small style={{ fontSize: 10 }}>
                    ({item?.count ? formatNumberWithCommas(item.count) : 0})
                  </small>
                </span>
              </div>
            </li>
          )
        })}
      </ul>
    )
  }

  useEffect(() => {
    const { data, loading, error } = fetchReports
    if (loading) setMapDataLoaded(true)
    if (!loading) {
      if (error) {
        setMapDataLoaded(false)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      }
      if (data?.getAllReportsFlat?.length === 0) {
        return setReportsData(reportsDataInitial)
      }

      setCountsReportZones(null)
      if (data?.getAllReportsFlat.length > 0) {
        const countByZone = data?.getAllReportsFlat.reduce((acc, item) => {
          const { zone_id } = item
          acc[zone_id] = (acc[zone_id] || 0) + 1
          return acc
        }, {})
        setCountsReportZones(countByZone)
      }

      const array_attended_reports = [
        statusMap.Cancelado,
        statusMap.Solucionado,
      ]

      const list_open_reports = []
      const list_attended_reports = []

      data?.getAllReportsFlat?.map((item) => {
        const { status_id } = item
        if (array_attended_reports.includes(status_id))
          list_attended_reports.push(item)
        else list_open_reports.push(item)
      })

      const listKpiCounts = []

      if (filters.status_report_type === 'open_reports') {
        listKpiCounts.push({
          title: 'Reportes en proceso',
          value: `${formatNumberWithCommas(list_open_reports.length)}`,
          iconContent: <i className="fas fa-check colorGreen" />,
        })
      }

      if (filters.status_report_type === 'attended_reports') {
        listKpiCounts.push({
          title: 'Reportes atendidos',
          value: `${formatNumberWithCommas(list_attended_reports.length)}`,
          iconContent: <i className="fas fa-check colorGreen" />,
        })
      }

      if (filters.status_report_type === 'all_reports') {
        listKpiCounts.push({
          title: 'Cantidad de reportes',
          value: `${formatNumberWithCommas(
            data?.getAllReportsFlat.length || 0
          )}`,
          iconContent: <i className="fas fa-check colorGreen" />,
          extraContent: (
            <div style={{ fontSize: '12px', color: '#666' }}>
              <div>
                <span className="fw-bold">En proceso: </span>
                {formatNumberWithCommas(list_open_reports.length)}
              </div>
              <div>
                <span className="fw-bold">Atendidos: </span>
                {formatNumberWithCommas(list_attended_reports.length)}
              </div>
            </div>
          ),
        })
      }

      setKpiCounts(listKpiCounts)

      setReportsData({
        open_reports: list_open_reports,
        attended_reports: list_attended_reports,
        total: data?.getAllReportsFlat.length,
      })
      setMapDataLoaded(false)
    }
  }, [fetchReports.data, fetchReports.loading, fetchReports.error, filters])

  useEffect(() => {
    const { data, loading, error } = fetchCategories
    if (!loading) {
      if (error) {
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      }
      if (data?.categories.length === 0) {
        setOptions((old) => ({ ...old, categories: [] }))
        return
      }
      let categories = []
      data?.categories?.map((category) => {
        categories.push({
          value: category.id,
          label: category.name,
        })
      })
      setOptions((old) => ({ ...old, categories }))
    }
  }, [fetchCategories.data, fetchCategories.loading, fetchCategories.error])

  useEffect(() => {
    const { data, loading, error } = fetchJurisdictions
    if (!loading) {
      if (error) {
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      }
      let zones = []
      data?.getAllJurisdictionsAndSubs.map((item) => {
        const { SubsOfJurisdiction } = item
        SubsOfJurisdiction?.map((sub) => {
          zones.push({ value: sub.id, label: sub.name })
        })
      })
      setOptions((old) => ({ ...old, zones }))
    }
  }, [
    fetchJurisdictions.data,
    fetchJurisdictions.loading,
    fetchJurisdictions.error,
  ])

  useEffect(() => {
    if (
      countsReportZones &&
      options.zones.length > 0 &&
      reportsData?.total > 0
    ) {
      const list = []

      options.zones.map((zone) => {
        const count = countsReportZones[zone.value]
        const percentage = count ? (count / reportsData?.total) * 100 : 0
        const roundedPercentage = Math.round(percentage * 100) / 100
        return list.push({
          id: zone.value,
          name: zone.label,
          percentage: roundedPercentage,
          count: count || 0,
        })
      })

      //Por default acomodar de mayor a menor las zonas
      const sortedZones = [...list].sort((a, b) => b.percentage - a.percentage)
      setActiveSort('desc')

      setDataZoneCountsOrigin(list)
      setDataZoneCounts(sortedZones)
    }
  }, [options.zones, countsReportZones, reportsData.total])

  const handleSetPrioritySpecial = (value) => {
    setFilters((prev) => ({
      ...prev,
      special_priority: value,
    }))
  }

  return (
    <>
      <ContentHeader
        title="Reportes / Mapa de calor"
        breadcrumb=""
        windowTitle="Reportes / Mapa de calor"
      />

      <div className="row dashboard-admin-master-mayor reports-heat-map px-2 py-0">
        <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 filters-box">
          <div className="row">
            <CategoryFilter
              titleContent={<label>Reportes{` `}</label>}
              placeholder="Todos"
              options={options_status_report}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  status_report_type: e.value,
                })
              }}
              showValue={true}
              value={options_status_report.find(
                (item) => item.value === filters.status_report_type
              )}
              isMulti={false}
            />
          </div>
          <div className="row">
            <CategoryFilter
              titleContent={
                <label>
                  Categorías{` `}
                  <small style={{ fontSize: '0.7rem' }}>
                    (Elige una o varias opciones)
                  </small>
                </label>
              }
              placeholder="Todas las categorías"
              options={options.categories}
              onChange={handleChangeFilterCategories}
              showValue={false}
              value={options.categories.filter((item) =>
                filters.array_group_category_id?.includes(item.value)
              )}
              isMulti={true}
              param={'array_group_category_id'}
            />
          </div>
          <div className="row">
            <CategoryFilter
              titleContent={
                <label>
                  Subcategorías{` `}
                  <small style={{ fontSize: '0.7rem' }}>
                    (Elige una o varias opciones)
                  </small>
                </label>
              }
              placeholder="Todas las subcategorías"
              options={options.subcategories}
              onChange={handleChangeFilterCategoriesSub}
              showValue={false}
              value={options.subcategories.filter((item) =>
                filters.array_group_category_sub_id?.includes(item.value)
              )}
              isMulti={true}
              param={'array_group_category_sub_id'}
            />
          </div>
          <div className="row">
            <CategoryFilter
              titleContent={
                <label>
                  Zonas{` `}
                  <small style={{ fontSize: '0.7rem' }}>
                    (Elige una o varias opciones)
                  </small>
                </label>
              }
              placeholder="Todas las zonas"
              options={options.zones}
              onChange={handleFilterMultiplySelection}
              showValue={false}
              value={options.zones.filter((item) =>
                filters.array_zones_id?.includes(item.value)
              )}
              isMulti={true}
              param={'array_zones_id'}
            />
          </div>
          <div className="row">
            <div className="col-12 mb-3">
              <label htmlFor="start_date">Fecha inicio:</label>
              <div className="pl-2">
                <DatePickerInput
                  id="start_date"
                  name="start_date"
                  type="date"
                  className="input-field form-control position-searchInput"
                  placeholder="Elige"
                  onChange={(e) => {
                    setFilters((old) => ({
                      ...old,
                      dateFrom: e.target?.value || null,
                    }))
                  }}
                  value={filters?.dateFrom ?? ''}
                  defaultValue={filters?.dateFrom ?? ''}
                  styleBtn={{ zIndex: 0 }}
                />
              </div>
            </div>
            <div className="col-12 mb-3">
              <label htmlFor="end_date">Fecha fin:</label>
              <div className="pl-2">
                <DatePickerInput
                  id="end_date"
                  name="end_date"
                  type="date"
                  className="input-field form-control position-searchInput"
                  placeholder="Elige"
                  onChange={(e) => {
                    setFilters((old) => ({
                      ...old,
                      dateTo: e.target?.value || null,
                    }))
                  }}
                  value={filters?.dateTo ?? ''}
                  defaultValue={filters?.dateTo ?? ''}
                  styleBtn={{ zIndex: 0 }}
                />
              </div>
            </div>
            <div className="row">
              <label style={{ userSelect: 'none' }}>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={filters.special_priority}
                    className="switch-filter-2"
                    onChange={(e) => handleSetPrioritySpecial(e.target.checked)}
                    style={{ marginRight: '5px' }}
                  />
                  <span style={{ fontSize: '0.8em' }}>
                    Gestores de cercania
                  </span>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 reports-heat-map-right">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
              <div className="cards-box">
                <KpiMultiCards cards={kpiCounts} />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
              <div className="percentages-by-categories-box pb-0 flex-grow-1">
                <div className="header d-flex justify-content-between align-items-center pb-2">
                  <h5>Reportes por zonas</h5>
                  {dataZoneCounts?.length > 0 && (
                    <div className="divBtnShort">
                      <button
                        className={`btnShort btn btn-sm btn-outline-primary mr-2 ${
                          activeSort === 'desc' ? 'active' : ''
                        }`}
                        onClick={() => {
                          if (activeSort === 'desc') {
                            setActiveSort(null)
                            setDataZoneCounts(dataZoneCountsOrigin)
                          } else {
                            const sortedZones = [...dataZoneCounts].sort(
                              (a, b) => b.percentage - a.percentage
                            )
                            setDataZoneCounts(sortedZones)
                            setActiveSort('desc')
                          }
                        }}
                      >
                        <i className="fas fa-caret-up" />
                      </button>
                      <button
                        className={`btnShort btn btn-sm ${
                          activeSort === 'asc' ? 'active' : ''
                        }`}
                        onClick={() => {
                          if (activeSort === 'asc') {
                            setActiveSort(null)
                            setDataZoneCounts(dataZoneCountsOrigin)
                          } else {
                            const sortedZones = [...dataZoneCounts].sort(
                              (a, b) => a.percentage - b.percentage
                            )
                            setDataZoneCounts(sortedZones)
                            setActiveSort('asc')
                          }
                        }}
                      >
                        <i className="fas fa-caret-down" />
                      </button>
                    </div>
                  )}
                </div>
                <div className="body p-0 pt-2">
                  {dataZoneCounts?.length > 0 && getTableCountZones()}
                </div>
              </div>
            </div>
          </div>
          {fetchReports.loading || mapDataLoaded ? (
            <div className="d-flex align-items-center justify-content-center">
              <Loader />
            </div>
          ) : (
            <div className="row mt-3">
              <Box
                title=""
                contentHeader=""
                classNameHeader="col-12"
                classCardBody="card-body px-0"
                content={
                  <HeatMapZones
                    reportsData={reportsData}
                    openHeatmapOptions={{
                      radius: 25,
                      dissipating: true,
                      opacity: 0.65,
                      maxIntensity: 1,
                      // maxIntensity:
                      //   filters.status_report_type === 'attended_reports'
                      //     ? 100
                      //     : 250, // Ajusta la intensidad máxima, // Ajusta la intensidad máxima
                      gradient:
                        filters.status_report_type === 'all_reports'
                          ? [
                              'rgba(255, 192, 203, 0)', // Rosa claro transparente (inicio)
                              'rgb(203, 100, 32)', // Rosa claro
                              'rgb(221, 96, 13)', // Rosa intenso (hot pink)
                              'rgba(247, 104, 8, 1)', // Rosa medio (pale violet red)
                              'rgba(247, 104, 8, 1)', // Fucsia oscuro (deep pink)
                            ]
                          : filters.status_report_type === 'open_reports'
                          ? [
                              'rgba(90, 40, 90, 0)', // Púrpura oscuro transparente
                              'rgba(120, 50, 100, 1)', // Rosa profundo oscuro
                              'rgba(150, 40, 100, 1)', // Hot pink oscuro
                              'rgba(130, 30, 90, 1)', // Rosa medio más apagado
                              'rgba(110, 20, 80, 1)', // Fucsia oscuro más profundo
                            ]
                          : [
                              'rgba(255, 192, 203, 0)', // Rosa claro transparente (inicio)
                              'rgb(131, 91, 186)', // Rosa claro
                              'rgb(100, 53, 166)', // Rosa intenso (hot pink)
                              'rgb(110, 31, 222)', // Rosa medio (pale violet red)
                              'rgb(108, 8, 247)', // Fucsia oscuro (deep pink)
                            ],
                    }}
                    attendedHeatmapOptions={{
                      radius: 25,
                      dissipating: true,
                      opacity: 0.65,
                      maxIntensity: 1,
                      // filters.status_report_type === 'attended_reports'
                      //   ? 20
                      //   : 250,
                      gradient:
                        filters.status_report_type === 'all_reports'
                          ? [
                              'rgba(255, 192, 203, 0)', // Rosa claro transparente (inicio)
                              'rgb(203, 100, 32)', // Rosa claro
                              'rgb(221, 96, 13)', // Rosa intenso (hot pink)
                              'rgba(247, 104, 8, 1)', // Rosa medio (pale violet red)
                              'rgba(247, 104, 8, 1)', // Fucsia oscuro (deep pink)
                            ]
                          : filters.status_report_type === 'open_reports'
                          ? [
                              'rgba(255, 192, 203, 0)', // Rosa claro transparente (inicio)
                              'rgba(255, 192, 203, 1)', // Rosa claro
                              'rgba(255, 105, 180, 1)', // Rosa intenso (hot pink)
                              'rgba(219, 112, 147, 1)', // Rosa medio (pale violet red)
                              'rgba(199, 21, 133, 1)', // Fucsia oscuro (deep pink)
                            ]
                          : [
                              'rgba(255, 192, 203, 0)', // Rosa claro transparente (inicio)
                              'rgb(131, 91, 186)', // Rosa claro
                              'rgb(100, 53, 166)', // Rosa intenso (hot pink)
                              'rgb(110, 31, 222)', // Rosa medio (pale violet red)
                              'rgb(108, 8, 247)', // Fucsia oscuro (deep pink)
                            ],
                    }}
                  />
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ReportsHeatMap
